// comes from https://github.com/imcvampire/vue-truncate-filter/blob/master/vue-truncate.js
export default function truncate(text, length, clamp) {
  const safeText = text || '';
  const safeClamp = clamp || '...';
  const safeLength = length || 30;

  if (safeText.length <= safeLength) return safeText;

  let tcText = safeText.slice(0, safeLength - safeClamp.length);
  let last = tcText.length - 1;

  while (last > 0 && tcText[last] !== ' ' && tcText[last] !== safeClamp[0]) {
    last -= 1;
  }

  // Fix for case when text dont have any `space`
  last = last || safeLength - safeClamp.length;

  tcText = tcText.slice(0, last);

  return tcText + safeClamp;
}
